import { buildYearQuarterTreeOptions, DateItem } from '@/api/hcp/partnerscore/utils/yearQuarterTreeUtils';
import { FilterConfigDynamic } from '@/types/filter';
import { SelectItem } from '@/types/ui';
import { toNumberOrNull } from '@/utils/cube';

const CUBE_NAME = 'competitor_partner_score';
const YEAR_DIM = `${CUBE_NAME}.year`;
const QUARTER_DIM = `${CUBE_NAME}.quarter`;

const competitorYearQuarterFilter: FilterConfigDynamic = {
  label: 'main.hcpOverview.partnerScore.filter.yearQuarter',
  placeholder: 'main.hcpOverview.partnerScore.filter.yearQuarter',
  type: 'oldtreeselect',
  defaultValue: [],
  clearable: false,
  sourceCube: CUBE_NAME,
  getOptionsQuery: () => ({
    dimensions: [YEAR_DIM, QUARTER_DIM],
    limit: 5000,
  }),
  mapResult: result => {
    const year = toNumberOrNull(result[YEAR_DIM]);
    const quarter = toNumberOrNull(result[QUARTER_DIM]);
    if (!year || !quarter) return null;
    return { value: JSON.stringify({ year, quarter }), label: '' };
  },
  processOptions: (options: SelectItem[]): SelectItem[] => {
    const dateItems: DateItem[] = options
      .map(opt => {
        try {
          return JSON.parse(opt.value) as DateItem;
        } catch {
          return null;
        }
      })
      .filter((item): item is DateItem => item !== null);

    return buildYearQuarterTreeOptions(dateItems);
  },
  applyFilter: value => {
    const v = value as string[];
    if (!v?.length) return undefined;
    // Year/quarter filtering is handled by useCompetitorFilter utility functions,
    // not by a direct cube filter.
    return undefined;
  },
};

export default competitorYearQuarterFilter;
